import * as yup from 'yup';

export const UpdateConf = {
  schema: yup.object({
    note: yup.string().nullable(),
  }),
  defaultValues: {
    note: null,
  },
  fields: [
    {
      id: 'delivery_note',
      type: 'divider',
      label: 'Delivery Note',
      xs: 12,
    },
    {
      id: 'note',
      name: 'note',
      type: 'text',
      label: 'Note',
      xs: 12,
      rows: 3,
      multiline: true,
    },
  ],
};
